const isPristine = Symbol('isPristine')

export { isPristine }
